var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "27ec49e7e0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 109.675781 121.613281 L 173.859375 121.613281 L 173.859375 201.605469 L 109.675781 201.605469 Z M 109.675781 121.613281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "72f8d89a66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49.835938 49.773438 L 233.839844 49.773438 L 233.839844 141.238281 L 49.835938 141.238281 Z M 49.835938 49.773438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f46a7f255a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 141.769531 49.773438 L 233.699219 141.238281 L 49.835938 141.238281 Z M 141.769531 49.773438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1a5f22e731"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49.84375 200.6875 L 109.679688 200.6875 L 109.679688 265.632812 L 49.84375 265.632812 Z M 49.84375 200.6875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b176e00169"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 233.691406 141.234375 L 325.15625 141.234375 L 325.15625 325.234375 L 233.691406 325.234375 Z M 233.691406 141.234375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f6b36d6aed"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 325.15625 233.164062 L 233.691406 325.09375 L 233.691406 141.234375 Z M 325.15625 233.164062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c349eb51ec"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 109.675781 265.640625 L 173.859375 265.640625 L 173.859375 325.226562 L 109.675781 325.226562 Z M 109.675781 265.640625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "29f77c4764"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49.84375 201.597656 L 109.679688 201.597656 L 109.679688 266.542969 L 49.84375 266.542969 Z M 49.84375 201.597656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1a1ff62ee8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 173.859375 201.605469 L 249.117188 201.605469 L 249.117188 266.546875 L 173.859375 266.546875 Z M 173.859375 201.605469 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#27ec49e7e0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 109.675781 121.613281 L 173.859375 121.613281 L 173.859375 201.59375 L 109.675781 201.59375 Z M 109.675781 121.613281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#72f8d89a66)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f46a7f255a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 49.835938 49.773438 L 233.839844 49.773438 L 233.839844 141.238281 L 49.835938 141.238281 Z M 49.835938 49.773438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1a5f22e731)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 49.84375 265.632812 L 49.84375 200.652344 L 109.679688 200.652344 L 109.679688 265.632812 Z M 49.84375 265.632812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b176e00169)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f6b36d6aed)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 325.15625 141.234375 L 325.15625 325.234375 L 233.691406 325.234375 L 233.691406 141.234375 Z M 325.15625 141.234375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c349eb51ec)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 109.675781 265.640625 L 173.917969 265.640625 L 173.917969 325.226562 L 109.675781 325.226562 Z M 109.675781 265.640625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#29f77c4764)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 49.84375 266.542969 L 49.84375 201.5625 L 109.679688 201.5625 L 109.679688 266.542969 Z M 49.84375 266.542969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1a1ff62ee8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 173.859375 266.546875 L 173.859375 201.605469 L 249.207031 201.605469 L 249.207031 266.546875 Z M 173.859375 266.546875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.28862e9d376cf270c91cec07164d92a9.svg";
export { ForwardRef as ReactComponent };